export const NAME_PATERN = /^[A-Za-z]+$/;
